<template>
  <base-draggable-modal
      name="edit_field"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="edit_field">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-text-field
                density="default"
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.name"
                :disabled="!canEdit"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('name') }}<strong>*</strong></span>
              </template>
            </v-text-field>
            <v-autocomplete
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.field_type"
                :items="field_types"
                :disabled="!canEdit"
                :return-object="false"
                item-value="value"
                item-title="text"
                hide-details
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('field_type') }}<strong>*</strong></span>
              </template>
            </v-autocomplete>
            <v-combobox
                v-if="record.field_type === 'select_single' || record.field_type === 'select_multiple'"
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.available_options"
                :disabled="!canEdit"
                chips
                closable-chips
                hide-details
                clearable
                multiple>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('options') }}</span>
              </template>
            </v-combobox>
            <v-row class="mt-3">
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details :readonly="!canEdit" v-model="record.mandatory"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('mandatory') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details :readonly="!canEdit" v-model="record.show_in_search"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_in_search') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details :readonly="!canEdit" v-model="record.show_on_creation"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_on_creation') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details :readonly="!canEdit" v-model="record.show_on_update"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_on_update') }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('edit_field')">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button v-if="canEdit" :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "../../components/commonComponents/BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX,
  },
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  data() {
    return {
      page: helpFunctions.pages.fields,
      record: {},
      field_types: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(id) {
      this.record = {};
      this.field_types = this.$lodash.sortBy(helpFunctions.field_types, 'text');
      this.openModal('edit_field');
      this.record = await helpFunctions.loadModel(this.$toast, this.page.name, id);
    },
    async save() {
      let usual_fields_required = [{name: 'name', mandatory: true}, {name: 'field_type', mandatory: true}];
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, usual_fields_required)) {
        if(await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
          this.$emit('refresh');
          this.closeModal('edit_field');
        }
      }
    },
  },
  computed: {
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: this.record.id }));
    },
  },
};
</script>